interface TrendBadgeProps {
  trend: "up" | "down" | "new" | "flat";
  value: number;
}

export default function TrendBadge({ trend, value }: TrendBadgeProps) {
  if (trend === "new") {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-xs font-label font-medium text-accent-800">
        <i className="ri-add-line"></i>
        新上榜
      </span>
    );
  }

  if (trend === "flat") {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-label text-secondary-800">
        <i className="ri-subtract-line"></i>
        持平
      </span>
    );
  }

  const isUp = trend === "up";
  return (
    <span
      className={
        isUp
          ? "inline-flex items-center gap-1 rounded-full bg-primary-100 px-2 py-0.5 text-xs font-label font-medium text-primary-700"
          : "inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2 py-0.5 text-xs font-label text-secondary-700"
      }
    >
      <i className={isUp ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
      {isUp ? "+" : "-"}
      {value}
    </span>
  );
}